import React, {useEffect, useRef, useState} from 'react';
import {CloseOutlined, SearchOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import classes from '../courses.module.css';

/**
 * Поле поиска в герое каталога.
 *
 * Значение живёт в URL, но писать туда каждый символ нельзя — засорится история
 * браузера. Поэтому локальный стейт + дебаунс 120 мс: сама фильтрация двенадцати
 * записей укладывается в кадр, дебаунс нужен только чтобы не дёргать перестроение
 * сетки на каждой букве.
 *
 * type="text", а не "search": у search-инпута Chrome рисует собственный крестик
 * очистки, и рядом с нашим их получалось два.
 */
const SearchField = ({value, onChange}) => {
    const {t} = useTranslation();
    const [local, setLocal] = useState(value || '');
    const inputRef = useRef(null);

    // внешняя смена (сброс фильтров, переход по ссылке) должна доезжать до поля
    useEffect(() => {
        setLocal(value || '');
    }, [value]);

    useEffect(() => {
        if (local === (value || '')) return undefined;
        const id = setTimeout(() => onChange(local), 120);
        return () => clearTimeout(id);
    }, [local]); // eslint-disable-line react-hooks/exhaustive-deps

    const clear = () => {
        setLocal('');
        onChange('');
        inputRef.current?.focus();
    };

    return (
        <div className={classes.searchWrap}>
            <SearchOutlined className={classes.searchIcon}/>
            <input
                ref={inputRef}
                className={classes.searchInput}
                type="text"
                inputMode="search"
                autoComplete="off"
                value={local}
                placeholder={t('coursesPage.search.placeholder')}
                onChange={(e) => setLocal(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        clear();
                        e.currentTarget.blur();
                    }
                }}
                aria-label={t('coursesPage.search.placeholder')}
            />
            {local && (
                <button
                    type="button"
                    className={classes.searchClear}
                    onClick={clear}
                    aria-label={t('coursesPage.search.clear')}
                >
                    <CloseOutlined/>
                </button>
            )}
        </div>
    );
};

export default SearchField;
